import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { startCancelReceipt, setInputQuantityNegative, setPriceList, emptyReceipt } from '../actions/receiptActions.js'
import { startCancelReceiptKiosk, confirmOrder } from '../kiosk/actions/kioskActions'
import { resetCustomer, resetPagerNumber } from '../actions/receiptActions.js'
import * as resource from '../constants/Resources'
import { setMessageModal, setConfirmModal, setKeyFunctionExecuted } from '../actions/generalActions'
import { getTranslation, getObjectItem } from '../actions/dataActions'
import { hasRight } from '../actions/rightsActions'
import * as right from '../constants/Rights'
import PropTypes from 'prop-types'
import * as types from '../constants/Types'
import { setOrderConfirmationModal } from '../modal/actions/modalActions'
import { startPayment } from '../functions/PaymentFunctions'
import { processFunction, processSelectPager } from '../actions/keyFunctionActions';
import * as functions from '../constants/Functions'

class ReceiptButton extends Component {
  constructor(props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap(e) {
    e.preventDefault();
    switch (this.props.type) {
      case types.RECEIPTBUTTON_STOP_RECEIPT:
        if (this.props.receiptnumber !== null
          || this.props.fetchreceiptnumber) {
          if (this.props.hasRight(right.POS_CANCELRECEIPT, true)) {
            this.props.startCancelReceipt();
          }
        }
        else {
          this.props.resetCustomer();
          this.props.resetPagerNumber();
        }

        this.props.setPriceList(this.props.defaultPricelistId);
        break;
      case types.RECEIPTBUTTON_RETOUR:
        let allowChange = true;
        if (this.props.hasRight(right.POS_RETOUR, true)) {
          if (this.props.blackbox
            && this.props.receiptnumber !== null
            && this.props.isrefund === false) {
            this.props.setMessageModal(true, this.props.getTranslation(resource.RETOUR_NOT_POSSIBLE));
            allowChange = false;
          }
          if (allowChange) {
            this.props.setInputQuantityNegative(!this.props.inputquantitynegative);
          }
        }
        break;
      case types.RECEIPTBUTTON_KIOSK_STOP_RECEIPT:
        if (this.props.receiptnumber !== null) {
          if (this.props.hasRight(right.POS_CANCELRECEIPT, true)) {
            this.props.startCancelReceiptKiosk();
          }
        }
        else {
          this.props.resetCustomer();
        }

        this.props.setPriceList(this.props.defaultPricelistId);
        break;
      case types.RECEIPTBUTTON_KIOSK_CONFIRM_ORDER:
        if (this.props.posType === types.POSTYPE_ORDERKIOSK) {
          if (this.props.receiptnumber !== null) {
            if (this.props.usePager) {
              if(this.props.pagerNumber === null || this.props.pagerNumber === 0) {
                this.props.processSelectPager();
              }
            }
            this.props.confirmOrder();
            let objectItemNumber = "";
            const objectItem = this.props.getObjectItem(this.props.selectedObjectItemId);
            if (objectItem !== null) {
              objectItemNumber = objectItem.ItemNumber;
            }
            this.props.setOrderConfirmationModal(true, objectItemNumber, this.props.receiptLines);
          }
        }
        if (this.props.posType === types.POSTYPE_SALESKIOSK) {
          if (this.props.receiptnumber !== null && this.props.receiptnumber >= 0) {
            if (this.props.usePager) {
              if(this.props.pagerNumber === null || this.props.pagerNumber === 0) {
                this.props.processSelectPager();
              }
            }
            this.props.startPayment();
          }
          else {
            this.props.setMessageModal(true, this.props.getTranslation(resource.NO_RECEIPTNUMBER));
          }
        }
        break;
      case types.RECEIPTBUTTON_EMPTY_RECEIPT:
        this.props.emptyReceipt(false);

        this.props.setKeyFunctionExecuted(functions.ObjectManagementOpen);
        break;
      case types.RECEIPTBUTTON_PROCESS_RECEIPT:
        this.props.processFunction(functions.ObjectManagementProcess);

        this.props.setKeyFunctionExecuted(functions.ObjectManagementOpen);
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <button key={this.props.key} onClick={this.handleTouchTap} >
        {this.props.desc}
        <Ink />
      </button>
    )
  }
}

ReceiptButton.propTypes = {
  key: PropTypes.number,
  desc: PropTypes.string,
  inputquantitynegative: PropTypes.bool,
  receiptnumber: PropTypes.number,
  fetchreceiptnumber: PropTypes.bool,
  isrefund: PropTypes.bool,
  cancelReceipt: PropTypes.func,
  setInputQuantityNegative: PropTypes.func,
  type: PropTypes.number,
  blackbox: PropTypes.bool,
  setMessageModal: PropTypes.func,
  setConfirmModal: PropTypes.func,
  startCancelReceiptKiosk: PropTypes.func,
  confirmOrder: PropTypes.func,
  setOrderConfirmationModal: PropTypes.func,
  getObjectItem: PropTypes.func,
  startPayment: PropTypes.func
}

function mapStateToProps(state) {
  return {
    inputquantitynegative: state.receiptState.input.inputquantitynegative,
    receiptnumber: state.receiptState.receipt.receiptnumber,
    fetchreceiptnumber: state.receiptState.receipt.fetchreceiptnumber,
    isrefund: state.receiptState.receipt.isrefund,
    blackbox: state.generalState.licenses.blackbox && state.generalState.hasBlackbox,
    selectedObjectItemId: state.receiptState.receipt.objectitemid,
    receiptLines: state.receiptState.receipt.lines,
    posType: state.generalState.posType,
    defaultPricelistId: state.generalState.defaultPricelistId,
    usePager: state.generalState.usePager,
    pagerNumber: state.receiptState.receipt.pagerNumber
  }
}

export default connect(mapStateToProps,
  {
    startCancelReceipt,
    resetCustomer,
    resetPagerNumber,
    setInputQuantityNegative,
    setMessageModal,
    setConfirmModal,
    getTranslation,
    hasRight,
    startCancelReceiptKiosk,
    confirmOrder,
    setOrderConfirmationModal,
    getObjectItem,
    startPayment,
    setPriceList,
    processFunction,
    setKeyFunctionExecuted,
    emptyReceipt,
    processSelectPager
  })(ReceiptButton)



// WEBPACK FOOTER //
// src/components/ReceiptButton.jsx